import styled from 'styled-components';
import { devices } from 'signup-constants/styles/viewports.styles';
export const StyledIllustration = styled.div.withConfig({
  displayName: "Messagingstyles__StyledIllustration",
  componentId: "sc-59g831-0"
})(["display:block;@media ", "{display:block;}"], devices.desktop);